/* ═══════════════════════════════════════════
   BAU BUNDLE — Events v2.5
   CTA Completa la Protezione
   ═══════════════════════════════════════════ */
(function () {
  'use strict';
  var BauBundleEvents = {
    _initialized: false,
    _addingToCart: false,

    init: function () {
      if (this._initialized) return;
      this._setupDelegation();
      this._setupClickOutside();
      this._initialized = true;
    },

    _setupDelegation: function () {
      var root = document.getElementById('bau-bundle-root');
      if (!root) return;
      var self = this;
      root.addEventListener('click', function (e) {
        var target = e.target;
        var trigger = target.closest('.bau-bundle__variant-trigger');
        if (trigger) {
          e.preventDefault(); e.stopPropagation();
          var key = trigger.dataset.productKey;
          if (key) window.BauBundleState.toggleDropdown(key);
          return;
        }

        var colorChip = target.closest('.bau-bundle__color-chip');
        if (colorChip) {
          e.preventDefault(); e.stopPropagation();
          var cpk = colorChip.dataset.productKey;
          var cc = colorChip.dataset.color;
          if (cpk && cc) {
            var resolveKey = (cpk === 'guinzaglio' && window.BauBundleState.activeLeashKey) ? window.BauBundleState.activeLeashKey : cpk;
            var current = window.BauBundleState.getState().selections[cpk] || {};
            var sizesForColor = window.BauBundleProducts.getSizesForColor(resolveKey, cc);
            var wanted = sizesForColor.find(function (x) {
              return x.available && current.size && String(x.size).toLowerCase() === String(current.size).toLowerCase();
            });
            if (!wanted) wanted = sizesForColor.find(function (x) { return x.available; });
            window.BauBundleState.selectByColorSize(cpk, cc, wanted ? wanted.size : null);
          }
          return;
        }

        var sizeBtn = target.closest('.bau-bundle__size-btn');
        if (sizeBtn) {
          e.preventDefault(); e.stopPropagation();
          if (sizeBtn.disabled) return;
          var pk = sizeBtn.dataset.productKey, color = sizeBtn.dataset.color, size = sizeBtn.dataset.size;
          if (pk && color && size) window.BauBundleState.selectByColorSize(pk, color, size);
          window.BauBundleState.closeDropdown();
          return;
        }

        var colorBtn = target.closest('.bau-bundle__color-select-btn');
        if (colorBtn) {
          e.preventDefault(); e.stopPropagation();
          var pk2 = colorBtn.dataset.productKey, c2 = colorBtn.dataset.color;
          if (pk2 && c2) window.BauBundleState.selectByColorSize(pk2, c2, null);
          window.BauBundleState.closeDropdown();
          return;
        }

        var colorRow = target.closest('.bau-bundle__dropdown-color-row');
        if (colorRow) {
          e.preventDefault(); e.stopPropagation();
          var group = colorRow.closest('.bau-bundle__dropdown-color-group');
          var dd = group && group.closest('.bau-bundle__dropdown');
          var pk3 = dd ? dd.dataset.productKey : null;
          var c3 = group ? group.dataset.color : null;
          if (pk3 && c3) {
            var sizes = window.BauBundleProducts.getSizesForColor(pk3 === 'guinzaglio' && window.BauBundleState.activeLeashKey ? window.BauBundleState.activeLeashKey : pk3, c3);
            var first = sizes.find(function (s) { return s.available; });
            if (first) window.BauBundleState.selectByColorSize(pk3, c3, first.size);
            else window.BauBundleState.selectByColorSize(pk3, c3, null);
          }
          window.BauBundleState.closeDropdown();
          return;
        }

        if (target.closest('.bau-bundle__dropdown')) {
          return;
        }

        if (target.closest('.bau-bundle__cta')) {
          e.preventDefault(); e.stopPropagation();
          self._handleAddToCart();
        }
      });
    },

    _setupClickOutside: function () {
      document.addEventListener('click', function (e) {
        var state = window.BauBundleState;
        if (!state || !state.openDropdown) return;
        var root = document.getElementById('bau-bundle-root');
        if (root && !root.contains(e.target)) state.closeDropdown();
      });
    },

    _openCartDrawer: function () {
      document.documentElement.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
      setTimeout(function () {
        var drawer = document.getElementById('cart-drawer');
        if (drawer && drawer.hasAttribute('open')) return;
        var trigger = document.querySelector('[aria-controls="cart-drawer"], [data-open-drawer="cart-drawer"], button[data-drawer-id="cart-drawer"]');
        if (trigger) { trigger.click(); return; }
        var cartLink = document.querySelector('a[href="/cart"]');
        if (cartLink) cartLink.click();
      }, 50);
    },

    _handleAddToCart: function () {
      if (this._addingToCart) return;
      var state = window.BauBundleState;
      if (!state) return;
      var items;
      try {
        items = state.getLineItems();
      } catch (err) {
        console.error('[BauBundle] Acquisto bloccato:', err);
        var errorBox = document.getElementById('bauBundleError');
        if (errorBox) errorBox.textContent = err.message || 'Impossibile completare il kit. Riprova.';
        return;
      }
      if (!items.length) return;

      this._addingToCart = true;
      var btn = document.getElementById('bauBundleAddToCart');
      var self = this;
      if (btn) {
        btn.disabled = true;
        btn.classList.add('bau-bundle__cta--loading');
        btn.innerHTML = '<span class="bau-bundle__cta-spinner"></span><span class="bau-bundle__cta-text">Aggiunta in corso…</span>';
      }

      var sections = [];
      try { document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } })); } catch (e) {}
      var body = { items: items };
      if (sections.length) { body.sections = sections.join ? sections.join(',') : sections; body.sections_url = window.location.pathname; }

      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
        .then(function (res) { if (!res.ok) return res.text().then(function (t) { throw new Error(t); }); return res.json(); })
        .then(function (addRes) {
          return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            if (addRes.sections) cart.sections = addRes.sections;
            var detail = { baseEvent: 'variant:add', cart: cart };
            if (addRes.sections) detail.sections = addRes.sections;
            document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: detail }));
            if (btn) {
              btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" width="20" height="20"><path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5"/></svg><span class="bau-bundle__cta-text">Aggiunto!</span>';
              btn.classList.remove('bau-bundle__cta--loading');
              btn.classList.add('bau-bundle__cta--success');
            }
            setTimeout(function () {
              self._openCartDrawer(); self._addingToCart = false;
              setTimeout(function () {
                if (btn) { btn.disabled = false; btn.classList.remove('bau-bundle__cta--success'); btn.innerHTML = '<span class="bau-bundle__cta-text">Completa la Protezione</span>'; }
              }, 2000);
            }, 150);
          });
        })
        .catch(function (err) {
          console.error('[BauBundle] Cart error:', err);
          self._addingToCart = false;
          if (btn) {
            btn.disabled = false; btn.classList.remove('bau-bundle__cta--loading');
            btn.innerHTML = '<span class="bau-bundle__cta-text">Riprova</span>';
            setTimeout(function () { btn.innerHTML = '<span class="bau-bundle__cta-text">Completa la Protezione</span>'; }, 2000);
          }
        });
    }
  };
  window.BauBundleEvents = BauBundleEvents;
})();
